import React from 'react';
import { Box, Typography, Switch, Stack, CircularProgress } from '@mui/material';
import { Organization } from '@/types';
import useDeliveryControl from '@/hooks/useDeliveryControl';

interface DeliveryDisabledMessageProps {
  organization?: Organization | null;
}

const DeliveryDisabledMessage: React.FC<DeliveryDisabledMessageProps> = () => {
  const { isDeliveryEnabled, toggleDelivery, isLoading } = useDeliveryControl();

  const handleToggleDelivery = async (event: React.ChangeEvent<HTMLInputElement>) => {
    await toggleDelivery(event.target.checked);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        component="img"
        src="https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2Fdelivery-driver.webp?alt=media&token=78ded6a4-fd50-41fd-9949-946c4624f88c"
        alt="Delivery Driver"
        sx={{ width: 150, mb: 2, objectFit: 'contain' }}
      />
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Delivery Desactivado
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 250 }}>
        Tus clientes no pueden realizar pedidos en este momento. Activa el
        servicio para empezar a recibir órdenes.
      </Typography>

      <Stack direction="column" alignItems="center" spacing={1}>
        {isLoading ? (
          <CircularProgress size={38} />
        ) : (
          <Switch
            checked={isDeliveryEnabled}
            onChange={handleToggleDelivery}
            color="primary"
            size="medium"
            sx={{
              transform: 'scale(1.5)',
              mb: 1
            }}
          />
        )}
        <Typography variant="subtitle2" color="text.primary">
          Habilitar Delivery
        </Typography>
      </Stack>
    </Box>
  );
};

export default DeliveryDisabledMessage;
